<div *ngFor="let data of alerts" id="toastsContainerTopRight"
    class="toasts-bottom fixed alert alert-dark">
    <div>
        <fa-icon class="iconsClass" aria-hidden="true" [icon]="['fas', 'circle-check']" size="lg"></fa-icon>
        <span>{{data.message}}</span>
    </div>
</div>